import { computed } from '@nuxtjs/composition-api';
import useCheckout from '~/composable/checkout/useCheckout';
import { CUSTOMER_TYPE } from '~/constants/CheckoutFlow';
import useTlmCart from '~/composable/useTlmCart';
import useNumberPorting from '~/composable/useNumberPorting';

export default function useLead (appContext) {
  const hubbleClient = appContext.$hubble;
  if (!appContext || !hubbleClient) {
    throw new Error('You must provide the nuxt app context to use this composable');
  }
  const { state } = useCheckout(appContext)
  const { customerInfo } = state
  const { subscriptionList, billingAddressFromCart, isNumberPorting, getItemAttributeFromCartItem } = useTlmCart(appContext);
  const { validateMobileNumber, teleOperatorInfo } = useNumberPorting(appContext)
  const leadInfo = computed(() => {
    const lead = {
      leadContactPermissionText: customerInfo.permissionText + customerInfo.linkText,
      phoneNumber: billingAddressFromCart?.value?.phone,
      email: billingAddressFromCart?.value?.email,
      flowType: 'SIGNUP-' + subscriptionList.value.sku,
      streetAddress: customerInfo.customerDetails.value.addressDTO.streetName +
        ' ' + customerInfo.customerDetails.value.addressDTO.houseNumber +
        ' ' + customerInfo.customerDetails.value.addressDTO.floor +
        ' ' + customerInfo.customerDetails.value.addressDTO.side,
      zipCode: customerInfo.customerDetails.value.addressDTO.postalCode,
      city: customerInfo.customerDetails.value.addressDTO.postalDistrict
    }
    if (customerInfo.menu.value === CUSTOMER_TYPE.PRIVATE) {
      lead.name = customerInfo.privateInfo.name
    } else {
      lead.cvrNumber = customerInfo.businessInfo.cvr
      lead.companyName = customerInfo.businessInfo.billingAddress.company
    }
    if (isNumberPorting(subscriptionList.value)) {
      lead.importDate = getItemAttributeFromCartItem(subscriptionList.value, 'IsImmediateNpRequest') === 'true' ? 'ASAP' : 'AFTER_CONTRACT'
      lead.exportOperator = teleOperatorInfo.value.name
      lead.numberPortingNumber = getItemAttributeFromCartItem(subscriptionList.value, 'PhoneNumber')
      lead.icc = getItemAttributeFromCartItem(subscriptionList.value, 'ICC')
    }
    return lead
  })
  const addLead = async () => {
    if (isNumberPorting(subscriptionList.value)) {
      await validateMobileNumber(getItemAttributeFromCartItem(subscriptionList.value, 'PhoneNumber'))
    }
    return await hubbleClient.lead.addLead(leadInfo.value);
  }
  return {
    addLead
  }
}
